export default {
  changePhoneNum: '修改手機號碼',
  changeEmailAdd: '修改郵箱',
  byPhone: '手機驗證',
  byEmail: '郵箱驗證',
  phoneNum: '手機號碼',
  email: '郵箱',
  address: '地址',
  password: '密碼',
  language: '語言',
  reset: '修改密碼',
  editPassword: '修改密碼',
  replace: '更換',
  change: '更換',
  p1: '如果您需要添加銀行賬戶，請撥打客戶服務電話',
  resetTradeAccount: '重置交易賬戶密碼',
  resetPassword: '重置',
  mt5label: '槓桿式外匯賬戶',
  PMlabel: '黃金交易賬戶',
  stocksecuritiesCashlabel: '證券(現金)賬戶',
  stocksecuritiesMarginlabel: '證券(保證金)賬戶',
  futuresMarginlabel: '期貨賬戶',
  futuresDayTradingMarginlabel: '期貨日內交易賬戶',
  changePhoneNotice: '該功能僅提供給內地客戶使用',
  changeMt5Pwd: '修改外匯賬戶密碼',
  pwdTip: '新密碼必須是大小寫字母、數字及其組合，長度6-15位',
  masterPwd: '修改主密碼',
  pleaseEnterMaterPwd: '請輸入主密碼',
  readOnlyPwd: '修改只讀密碼',
  forgetPwd: '忘記密碼',
  modifyPwdSuccss: '密碼修改成功',
  modifyPwdSuccssTip: '您已成功更改密碼，請使用新密碼登錄。 ',
  resetPwd: '重置密碼',
  resetPwdTip: '您正在重置外匯交易密碼！點擊確定按鈕5分鐘後我們將發送密碼至您的登記郵箱<{email}>，確定重置？ ',
  commitSuccess: '提交成功',
  commitSuccessTip: '請前往您的登記郵箱<{email}>查看密碼',
  '404': '未找到',
  '405': '密碼不匹配',
  '406': '用戶不存在',
  '407': '參數不匹配',
  '408': '新密碼和確認密碼不匹配',
  '409': '舊密碼和原密碼不匹配',
  '410': '參數丟失 ',
  '411': '參數密鑰不允許',
  '412': '密碼長度不是6-12',
  '7000': '原密碼錯誤',
  '7001': '修改密碼失敗',
  '5003': '修改密碼發送郵件失敗',
  '10000': '修改交易賬戶失敗',
  '90000': '賬號未授權,請聯繫管理員',
  '90001': '登錄賬號或密碼不正確',
  '90002': '登錄賬號或密碼不正確',
  '90003': '登錄賬號或密碼不正確',
  '90004': '新密碼不符合規格',
  '90005': '登錄賬號或密碼不正確',
  '90006': '登錄賬號或密碼不正確',
  '90007': '修改密碼沒有返回結果',
  '90008': '登錄賬號或密碼不正確',
  '90009': '登錄賬號或密碼不正確',
  '90010': '頻繁操作,請稍後再試',
  '90011': '密碼已被使用',
  '10002': '登錄賬號或密碼不正確',
  '10004': '賬號未授權,請聯繫管理員',
  '10008': '登錄賬號或密碼不正確',
  '-986': '頻繁操作,請稍後再試',
  '-989': '修改密碼異常，請稍後再試',
  '12001': '登錄賬號或密碼不正確',
  '12003': '新密碼不符合規格',
  '12002': '密碼已被使用',
  '10013': '密碼錯誤，用戶凍結,請聯繫管理員',
  '10012': '用戶已被凍結,請聯繫管理員',
  '5008': '手機號碼格式不對,獲取驗證碼失敗',
  '40000': '獲取驗證碼失敗，請聯繫客服',
  setPassword: {
    '4001': '用戶不存在',
    '4014': '用戶來源錯誤',
    '4006': '密碼長度在6-16位之間',
    '4010': '參數缺失',
    '4008': '新密碼和確認密碼不一致',
    '4009': '輸入舊密碼和用戶原密碼不匹配',
    title: '更換個人中心密碼',
    oldPassword: '輸入你的舊密碼',
    newPassword: '輸入你的新密碼',
    confirmPassword: '再次輸入你的新密碼',
    submit: '提交',
    cancel: '取消',
    checkPassword: '密碼必須由6-16位數字和字母組成',
    checkTradePassword: '密碼格式不正確',
    checkPassWrongLen: '密碼長度為6-15位',
    passwordInconsistent: '兩次輸入的密碼不一致',
    fail: '修改密碼失敗',
    resetPhoneFail: '修改電話號碼失敗',
    notMatch: '舊密碼輸入錯誤,請重新輸入'
  },
  confirm: {
    title: '成功',
    p1: '您已成功更改了密碼',
    p2: '請用新密碼登錄',
    back: '回到登入'
  },
  changePhone: {
    title: '修改手機號碼',
    phoneTitle: '當前手機號',
    subtitle: `您正在更改認證手機！更換後您可以通過新的手機登錄和找回密碼`,
    codeInput: '請輸入有效的驗證碼',
    phoneInput: '請輸入手機號碼',
    phoneErr: '請輸入正確的電話號碼',
    areaErr: '請選擇區號',
    success: '修改電話號碼成功',
    expired: '驗證碼已過期',
    '413': '手機號已註冊',
    '4003': '手機號已註冊',
    '4001': '用戶信息有誤',
    registered: '手機號已被綁定',
    verCodeFail: '驗證碼錯誤,請重新輸入!',
    phoneNumPlaceholder: '手機號碼',
    verCodePlaceholder: '請輸入',
    sendVerTip: '獲取驗證碼',
    resetPhoneFail: '修改電話號碼失敗',
    samePhone: '該手機號與當前綁定手機號相同',
    sendSuccess: '驗證碼已發送至您的手機'
  },
  changePasswordMt5: {
    '30000': '請填寫密碼',
    '30001': '密碼複雜度不夠，請重新設置',
    '30002': '請輸入6-15位由大小寫字母和數字組成的密碼',
    messageVerify: '短信驗證',
    emailVerify: '郵箱驗證',
    inputNewPassword: '請輸入新密碼',
    inputNewPasswordAgain: '請再次輸入新密碼',
    title: '輸入新密碼',
    checkPassword: '請輸入6-15位由大小寫字母和數字組成的密碼'
  },
  changeEmail: {
    '413': '郵箱已註冊',
    '4003': '郵箱已註冊',
    '11013': '修改電話號碼失敗，請聯繫客服',
    emailEmpty: '郵箱不能為空',
    emailErr: '請輸入正確的郵箱',
    emailSame: '該郵箱與當前綁定郵箱相同',
    success: '修改郵箱成功',
    changeEmailFail: '修改郵箱失敗'
  },
  editAccountPassword: {
    securitiesMarginTitle: '修改證券(保證金)賬戶密碼',
    securitiesCashTitle: '修改證券(現金)賬戶密碼',
    futuresMarginTitle: '修改期貨賬戶密碼',
    futuresDayTradingMarginTitle: '修改期貨日內交易賬戶密碼'
  }
}
